import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: ''
}

const userSendPromptSlice = createSlice({
    name: 'userSendPrompt',
    initialState: initialState,
    reducers: {
        userSendPrompt: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { userSendPrompt } = userSendPromptSlice.actions;
export default {
    userSendPromptSlice: userSendPromptSlice.reducer,
}